export default __webpack_public_path__ + "static/media/Photo 11 - BR - Ventilation traversante.d21b768a.png";